export default __webpack_public_path__ + "static/media/Vera.8df1e527.jpg";